(function () {
  /**
   * SIDE_BAR
   * @param data
   * @constructor
   */
  function SideBar(data) {
    var sideBar = null,
      body = document.querySelector('body');

    var getTemplate = function (data) {
      var label = data.label.split(' '),
        labelTemplate = typeof data.imageLabel !== 'undefined' ? '<img class="side-bar__label-img" src="' + data.imageLabel + '" alt="rug"><div class="side-bar__label-body">' : '',
        positionClass = data.position === 'right' ? 'side-bar_right' : data.position === 'left' ? 'side-bar_left' : '',
        sizeClass = data.size === 50 ? 'side-bar_w50' : data.size === 33 ? 'side-bar_w33' : data.size === 25 ? 'side-bar_w25' : '',
        customClass = typeof data.customClass !== 'undefined' ? data.customClass : '';
      for (var i = 0; i < label.length; i++) {
        labelTemplate += '<span>' + label[i] + '</span>';
      }
      labelTemplate += '</div>';

      return '' +
        '<div class="side-bar ' + positionClass + ' ' + sizeClass + ' ' + customClass + '" data-side-bar>' +
        '    <div class="side-bar__content">' +
        '       <div class="side-bar__header">' +
        '           <span class="side-bar__header-text">' + data.header + '</span>' +
        '           <span class="side-bar__close" data-close>&#215;</span>' +
        '       </div>' +
        '       <div class="side-bar__body">' + data.body + '</div>' +
        '       <div class="side-bar__footer">' + data.footer + '</div>' +
        '       <div class="side-bar__label hide" data-label>' + labelTemplate + '</div>' +
        '    </div>' +
        '    <div class="side-bar__back" data-back style="display: none;"></div>' +
        '</div>'
    }

    this.setLabelText = function (label) {
      var labelButton = document.querySelector('[data-side-bar] [data-label] .side-bar__label-body');
      if (labelButton) {
        var labelTemplate = '';
        label = label.split(' ');
        for (var i = 0; i < label.length; i++) {
          labelTemplate += '<span>' + label[i] + '</span>';
        }
        labelButton.innerHTML = labelTemplate;
      }
    }

    this.getLabelText = function () {
      var labelButtonValues = document.querySelectorAll('[data-side-bar] [data-label] .side-bar__label-body span');
      if (labelButtonValues) {
        var value = [];
        for (var i = 0; i < labelButtonValues.length; i++) {
          value.push(labelButtonValues[i].innerText);
        }
        return value.join(' ');
      }
    }

    var show = function () {
      var back = sideBar.querySelector('[data-back]');
      back.style.display = 'block';
      setTimeout(function () {
        sideBar.classList.add('show');
      });
      body.classList.add('active');
    }

    var hide = function () {
      var back = sideBar.querySelector('[data-back]');
      setTimeout(function () {
        back.style.display = 'none';
      }, 500);

      sideBar.classList.remove('show');
      body.classList.remove('active');
    }

    this.show = show;
    this.hide = hide;

    var init = (function (body, data) {
      var defaultData = {
        position: 'right',
        label: '',
        header: '',
        body: '',
        footer: '',
      }
      data = Object.assign(defaultData, data);
      body.insertAdjacentHTML('beforeend', getTemplate(data));
      body.classList.add('side-bar-blur');
      sideBar = document.querySelector('[data-side-bar]');
      if (sideBar) {
        var closeButton = sideBar.querySelector('[data-close]'),
          labelButton = sideBar.querySelector('[data-label]'),
          back = sideBar.querySelector('[data-back]');


        setTimeout(function () {
          labelButton.classList.remove('hide');
        }, 500);


        if (closeButton) {
          closeButton.addEventListener('click', hide);
        }
        if (labelButton) {
          labelButton.addEventListener('click', function () {
            sideBar.classList.contains('show') ? hide() : show();
          });
        }
        if (back) {
          back.addEventListener('click', hide);
        }
      }
    })(body, data)
  }

  /**
   * FORM BUILDER
   * @constructor
   */
  function FormBuilder() {
    var
      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _getFormLine = function (field) {
        switch (field.type) {
          case 'text':
            return _renderInput(field);
          case 'select':
            return _renderSelect(field);
          case 'checkbox':
            return _renderCheckbox(field);
          case 'button':
          case 'submit':
            return _renderButton(field);
          case 'heading':
            return _renderHeader(field);
          case 'range':
            return _renderRangeSlider(field);
        }
      },

      _getHiddenClass = function(fieldStatus) {
      	var hiddenClass = '';
        if(fieldStatus === 1 && !window.shop.customer.isAdmin) {
        	hiddenClass = 'hide-admin-element';
        }
        return hiddenClass;
      }

      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderInput = function (field) {
        return '' +
          '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + ' ' + _getHiddenClass(field.admin_only) + '">' +
          '   <label class="els-form__header" for="' + _getIdField(field) + '">' + field.title + '</label>' +
          '   <input class="els-form__input" ' +
          '          id="' + _getIdField(field) + '" ' +
          '          type="' + field.type + '" ' +
          '          name="' + field.name + '" ' +
          '          value="' + field.value + '"/>' +
          '</li>';
      },

      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderSelect = function (field) {
        var optionList = field.options.map(function (option) {
          var selected = field.value === option.value ? 'selected' : '';
          return '<option value="' + option.value + '" ' + selected + '>' + option.label + '</option>';
        }).reduce(function (p, n) {
          return p + n;
        }, '');
        var emptyOption = field.value.length === 0 ? '<option value=""></option>' : '';
        return '' +
          '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + ' ' + _getHiddenClass(field.admin_only) + '">' +
          '   <label class="els-form__header" for="' + _getIdField(field) + '">' + field.title + '</label>' +
          '   <select id="' + _getIdField(field) + '" name="' + field.name + '">' +
          '       ' + emptyOption + optionList +
          '   </select>' +
          '</li>';
      },


      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderCheckbox = function (field) {
        var checkBoxesTemplate = field.options.map(function (option, index) {
          var checked = field.value === option.value ? 'checked' : '';
          return '' +
            '<label for="' + _getIdField(field) + '-' + index + '">' +
            '<input class="els-form__checkbox" ' +
            '       id="' + _getIdField(field) + '-' + index + '" ' +
            '       name="' + field.name + '_checkbox" ' +
            '       type="' + field.type + '"  ' +
            '       value="' + option.value + '" ' + checked + '>' +
            option.label + '</label>';
        }).reduce((p, n) => {
          return p + n;
        }, '');


        return '' +
          '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + ' ' + _getHiddenClass(field.admin_only) + '">' +
          '   <span class="els-form__header">' + field.title + '</span>' +
          '   <div class="els-form__checkbox-wrapper">' + checkBoxesTemplate + '</div>' +
          '</li>';
      },

      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderButton = function (field) {
        return '' +
          '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + '">' +
          '   <button class="els-form__button" ' +
          '           name="' + field.name + '" ' +
          '           type="' + field.type + '">' + field.title +
          '   </button>' +
          '</li>';
      },

      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderHeader = function (field) {
        return '' +
          '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + '">' +
          '   <span class="els-form__header">' + field.title + '</span>' +
          '</li>';
      },

      /**
       *
       * @param field
       * @returns {string}
       * @private
       */
      _renderRangeSlider = function (field) {
        var fieldId = _getIdField(field),
            inputRows;
       if(field.name !== "inch_wid_rgc_dym" && field.name !== "inch_len_rgc_dym") {
        	inputRows = '' +
              '   <div class="els-range__row">' +
              '       <div class="els-range__column els-range__column_left">' +
              '           <label for="' + fieldId + '-min">' + field.min.label + '</label>' +
              '           <input id="' + fieldId + '-min" ' +
              '                  type="number" ' +
              '                  class="els-range__input" ' +
              '                  name="' + field.name + '_min' + '" ' +
              '                  data-type="min" >' +
              '       </div>' +
              '       <div class="els-range__column els-range__column_right">' +
              '           <label for="' + fieldId + '-max">' + field.max.label + '</label>' +
              '           <input id="' + fieldId + '-max" ' +
              '                  type="number" ' +
              '                  class="els-range__input"' +
              '                  name="' + field.name + '_max' + '" ' +
              '                  data-type="max" >' +
              '       </div>' +
              '   </div>';
        } else {
        	inputRows = '' +
              '   <div class="onh-f-group-size">' +
          	  '	  	 Min <input value="0" data-type="min-ft" type=number name="'+ field.name +'_min_ft" class="onh-ignore onh-change"> ft. <input value="0" type=text data-type="min-inch" name="'+ field.name +'_min_inch" class="onh-ignore onh-change"> in.' +
        	  '	  </div>' +
        	  '   <div class="onh-f-group-size">' +
              '      Max <input type=number data-type="max-ft" name="'+ field.name +'_max_ft" class="onh-ignore onh-change"> ft. <input type=text name="'+ field.name +'_max_inch" data-type="max-inch" class="onh-ignore onh-change"> in.' +
        	  '   </div>';
        }

        var rangeTemplate = '' +
          '<div class="els-form__range els-range">' +
          '   <span class="els-form__header">' + field.title + '</span>' +
          '   <div class="els-range__row">' +
          '       <div class="nstSlider els-range__slider" ' +
          '            data-range_min="' + field.min.value + '"' +
          '            data-range_max="' + field.max.value + '" ' +
          '            data-main-progress="' + field.mainProgress.value +'" ' +
          '            data-cur_min="' + field.min.value + '" ' +
          '            data-cur_max="' + field.max.value + '">' +
          '           <div class="highlightPanel"></div>' +
          '           <div class="bar els-range__bar"></div>' +
          '           <div class="leftGrip els-range__grip"></div>' +
          '           <div class="rightGrip els-range__grip"></div>' +
          '       </div>' +
          '   </div>'
          + inputRows +
          '</div>';
        return '<li class="els-form__line ' + _getSizeClass(field.cells) + ' ' + _getCustomClass(field.class) + ' ' + _getHiddenClass(field.admin_only) + '">' + rangeTemplate + '</li>'
      },

      /**
       *
       * @param fields
       * @param formId
       * @param isAdmin
       * @returns {string}
       * @private
       */
      _getFieldsTemplate = function (fields, formId, isAdmin) {
        if (typeof formId === 'undefined') {
          formId = 'form';
        }
        return fields.map(function (field) {
            field.formId = formId;
            if (!field.hasOwnProperty('cells')) {
              field.cells = 12;
            }
            return _getFormLine(field);
        }).reduce(function (p, n) {
          return p + n;
        }, '');
      },

      /**
       *
       */
      _initRange = function () {
        var isMoved = false;
        $('.els-form__range .nstSlider').nstSlider({
          "left_grip_selector": ".leftGrip",
          "right_grip_selector": ".rightGrip",
          "value_bar_selector": ".bar",
          "value_changed_callback": function (cause, minValue, maxValue) {
            var range = $(this),
                inFeets = range.parent().siblings('.onh-f-group-size').length === 2;

            if(inFeets) {
              	$inputs = range.parent().siblings('.onh-f-group-size');
              	var $minBox,
                    $maxBox;

              	$.each($inputs, function(index, input){
                    if (index === 0) {
                    	$minBox = $(input);
                    } else {
                    	$maxBox = $(input);
                    }
				});

            	var minFtInput = $minBox.find('[data-type="min-ft"]'),
                    minInchInput = $minBox.find('[data-type="min-inch"]'),
                    maxFtInput = $maxBox.find('[data-type="max-ft"]'),
                    maxInchInput = $maxBox.find('[data-type="max-inch"]'),
                    minFtValue = +minFtInput.val(),
              		  minInchValue = +minInchInput.val(),
                    maxFtValue = +maxFtInput.val(),
                    maxInchValue = +maxInchInput.val();
            } else {
            	var minInput = range.parent().parent().find('[data-type="min"]'),
                    maxInput = range.parent().parent().find('[data-type="max"]'),
                    minInputValue = +minInput.val(),
                    maxInputValue = +maxInput.val();
            }

            var move = function (type) {
                if ((cause === 'drag_move' || cause === 'drag_start') && !isMoved) {
                  isMoved = true;
                  setTimeout(function () {
                    var input;
                    switch(type) {
                      case 'min':
                        input = minInput;
                        break;
                      case 'max':
                        input = maxInput;
                        break;
                      case 'min-ft':
                        input = minFtInput;
                        break;
                      case 'min-inch':
                        input = minInchInput;
                        break;
                      case 'max-ft':
                        input = maxFtInput;
                        break;
                      case 'max-inch':
                        input = maxInchInput;
                    }

                    input.trigger('change');
                    isMoved = false;
                  }, 1000);
                }
            };

            if(inFeets) {
              if (cause === 'init') {
                minFtInput.val(Math.floor(minValue/12));
                minInchInput.val(minValue%12);
                maxFtInput.val(Math.floor(maxValue/12));
                maxInchInput.val(maxValue%12);
              }

              if (minValue !== minFtValue*12 + minInchValue) {
                minFtInput.val(Math.floor(minValue/12));
                minInchInput.val(minValue%12);
                move('min-ft');
                move('min-inch');


              }
              if (maxValue !== maxFtValue*12 + maxInchValue) {
                maxFtInput.val(Math.floor(maxValue/12));
                maxInchInput.val(maxValue%12);
                move('max-ft');
                move('max-inch');
              }
            } else {
              if (cause === 'init') {
                minInput.val(minValue);
                maxInput.val(maxValue);
              }
              if (minValue !== minInputValue) {
                minInput.val(minValue);
                move('min');
              }
              if (maxValue !== maxInputValue) {
                maxInput.val(maxValue);
                move('max');
              }
            }
          }
        });

        $('.els-form__range input').on('change', function (e) {
          var
            input = $(this),
            range = input.closest('.els-form__range').find('.nstSlider'),
            currentMinValue = range.nstSlider('get_current_min_value'),
            currentMaxValue = range.nstSlider('get_current_max_value'),
            minValue = range.nstSlider('get_range_min'),
            maxValue = range.nstSlider('get_range_max'),
            inFeets = range.parent().siblings('.onh-f-group-size').length === 2,
            value;

          if(inFeets) {
          	$inputs = range.parent().siblings('.onh-f-group-size');
            var $minBox,
                $maxBox;

            $.each($inputs, function(index, valueBox){
                if (index === 0) {
                   $minBox = $(valueBox);
                } else {
                   $maxBox = $(valueBox);
                }
			});

            if(input.attr('data-type') === 'max-ft' || input.attr('data-type') === 'max-inch') {
              	var $maxFtInput = $maxBox.find('[data-type="max-ft"]'),
                    $maxInchInput = $maxBox.find('[data-type="max-inch"]')
              	var feets = + $maxFtInput.val();
              	var inches = + $maxInchInput.val();
              	value = feets*12 + inches;
              	if (value > maxValue) {
                  	$maxFtInput.val(Math.floor(maxValue/12));
                  	$maxInchInput.val(maxValue%12);
          		}
            } else {
              	var $minFtInput = $minBox.find('[data-type="min-ft"]'),
                    $minInchInput = $minBox.find('[data-type="min-inch"]'),
            	    feets = + $minFtInput.val(),
              	    inches = + $minInchInput.val();
              	value = feets*12 + inches;

              	if (value < minValue) {
            		$minFtInput.val(Math.floor(minValue/12));
                  	$minInchInput.val(minValue%12);
          		}
            }
          } else {
          	value = input.val();
            if (value > maxValue) {
            	input.val(maxValue);
          	}
          	if (value < minValue) {
            	input.val(minValue);
          	}
          }

          var type = input.attr('data-type'),
              setMinValue = (type === 'min' || type === 'min-ft' || type === 'min-inch') ? value : currentMinValue,
              setMaxValue = (type === 'max' || type === 'max-ft' || type === 'max-inch') ? value : currentMaxValue;

          range.nstSlider('set_position', setMinValue, setMaxValue);
        });

        $('.els-form__range .nstSlider').each(function(){
          var mainProgress = + ($(this).attr('data-main-progress'));
          if(mainProgress > 0) {
            var maxSize = $(this).nstSlider('get_range_max');
            var histogram = [];
            var uEl = Math.round(mainProgress / maxSize * 100);
            var unEl = 100 - uEl;
            var uElVal = +((90 / uEl).toFixed(2));
            var unElVal = +((10 / unEl).toFixed(2));

            for(var i = 0; i < 100; i++) {
              if(uEl >= i) {
                histogram.push(uElVal);
              } else {
                histogram.push(unElVal);
              }
            }
            $(this).nstSlider('set_step_histogram', histogram);
          }
        });
      },

      /**
       *
       * @param cells
       * @returns {string}
       * @private
       */
      _getSizeClass = function (cells) {
        return 'els-form__w-12_mobile els-form__w-' + cells;
      },

      /**
       *
       * @param customClass
       * @returns {*}
       * @private
       */
      _getCustomClass = function (customClass) {
        return typeof customClass !== 'undefined' ? customClass : '';
      },

      /**
       *
       * @param field
       * @private
       */
      _getIdField = function (field) {
        //console.log('field.name');
        //console.log(field);
        return 'els-form-' + field.name + '-' + field.formId;
      };

    /**
     *
     * @param $formContainer
     * @param fields
     * @param formId
     * @param isAdmin
     */
    this.renderForm = function ($formContainer, fields, formId, isAdmin) {
      var topTotalBlock = window.shop.page === 'page/advanced-search' ? '<span class="els-form__text full top-total-box">Number Of Search Results: <span data-show-total>0</span></span>' : '';
      $formContainer.html(
        topTotalBlock +
        '<form class="els-form" enctype="multipart/form-data" action="/account" method="post" data-form-id="' + formId + '">' +
        '   <ul class="els-form__list">' + _getFieldsTemplate(fields, formId, isAdmin) + '</ul>' +
        '</form>'
      );
      _initRange();
    };

    /**
     *
     * @param $form
     * @returns {{}}
     */
    this.getFormData = function ($form) {
      var fields = $form.serializeArray();
      var feetsIssue = false;
      var currentSize = {};

      for (var i = 0; i < fields.length; i++) {
        var sizeWithFeets = fields[i]['name'].toLowerCase().match(/(_min_ft$)|(_min_inch$)|(_max_ft$)|(_max_inch$)/gi);
        if(sizeWithFeets) {
          	feetsIssue = true;
          	switch(sizeWithFeets[0]) {
              case '_min_ft':
              case '_max_ft':
                var name = fields[i]['name'].substr(0, fields[i]['name'].length - 3);
                currentSize.name = name;
                currentSize.value = (+fields[i]['value']) > 0 ? +fields[i]['value'] * 12 : 0;
                break;
              case '_min_inch':
              case '_max_inch':
                currentSize.value = (+currentSize.value > 0 ? +currentSize.value : 0) + (Number.parseInt(fields[i]['value']) > 0 ? Number.parseInt(fields[i]['value']) : 0);
                fields.push(currentSize);
                currentSize = {};
            }
        } else {
        	var name = fields[i]['name'].toLowerCase().match(/(_min$)|(_max$)/gi);
            if (name) {
              fields[i]['value'] = +fields[i]['value'];
            }
        }

      }

      if(feetsIssue) {
        for (var i = 0; i < fields.length; i++) {
        	var sizeWithFeets = fields[i]['name'].toLowerCase().match(/(_min_ft$)|(_min_inch$)|(_max_ft$)|(_max_inch$)/gi);
          	if(sizeWithFeets) {
            	fields.splice(i, 1);
              	i--;
            }
        }
      }

      return fields;
    }
  }

  /**
   * PRODUCTS_LIST
   * @param $container
   * @param $paginatorContainer
   * @param onPageChange
   * @param options
   * @constructor
   */
  function ProductsList($container, $paginatorContainer, onPageChange, options) {
    /**
     *
     * @param {Array} products
     */
    this.setProducts = function (products) {
      var productsData = '';
      var productsNumbers = products.length;
      for (var i = 0; i < products.length; i++) {
        if (((i + 1) % 3) === 0) {
          productsData += '<div class="product one-third column">' +
            getProductTemplate(products[i]) +
            '</div><div class="cf"></div>';
        } else {
          productsData += '<div class="product one-third column">' +
            '<div class="columnfluff"></div>' + getProductTemplate(products[i]) +
            '</div>';
        }
      }
      $container.html(productsData);
      window.collectionWishlistButtonInit();

      i = 0;

      function returnProductsSawPrices(p) {
        if (p.title.indexOf('RESERVED') === -1 && p.inventory_quantity > 0 && p.price !== '9999.00' && p.price !== 9999) {
          var url = 'https://oldnewhouse.com/products/' + p.handle + '?view=returnSawPrice-json';
          $.ajax({
            type: "GET",
            url: url,
            crossDomain: true,
            success: function (res) {
              var info = JSON.parse(res);
              var priceEl = document.querySelector('[price-handle="' + p.handle + '"]');
              if (priceEl && info.saw_compare_price !== info.saw_price) {
                priceEl.innerHTML = '' +
                  '<div class="price" style="height:16px;">' +
                  '   <span class="actual text_free_price">' +
                  '   <span class="actual text_free_price">' +
                  '   <span class="reducedfrom">' + info.saw_compare_price + '</span>' + info.saw_price + '</span></span>' +
                  '</div>';
              }

              if (typeof initProductIcons === 'function') {
                initProductIcons();
              }
            }
          });
        }
        i++;
        if (i !== productsNumbers) {
          returnProductsSawPrices(products[i]);
        } else {
          return [];
        }
      }

      if (productsNumbers > 0) {
        returnProductsSawPrices(products[i]);
      }

      if (typeof initProductIcons === 'function') {
        initProductIcons();
      }
      if (typeof addPreviewButton === 'function') {
        window.addPreviewButton();
      }
    };

    /**
     *
     * @param {Object} params
     */
    this.setPaginator = function (params) {
      $paginatorContainer.pagination({
        items: params.total,
        itemsOnPage: params.limit,
        currentPage: params.page,
        prevText: ' ',
        nextText: ' ',
        onPageClick: onPageChange
      });
    };

    var getSmallImagePath = function getSmallImagePath(path) {
      var parts = path.split('.j');
      return parts[0] + '_x400.j' + parts[1];
    };

    /**
     *
     * @param {Object} product
     * @returns {string}
     */
    var getProductTemplate = function (product) {
      var quickViewBtn = '<div handle="' + product.handle + '" class="quick-view-btn"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.640625 74.980469-181.019531s-26.628906-132.667969-74.980469-181.019531zm-181.019531 397.019531c-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216-96.898438 216-216 216zm20-236.019531h90v40h-90v90h-40v-90h-90v-40h90v-90h40zm0 0"/></svg></div>';
      var icon = '';
      if (product.product_icon_availability === 1) {
        icon = '<img ' +
          'style="display: inline-block; padding-left: 5px; max-height: 25px; max-width: 25px; margin-bottom: -5px;"' +
          ' class="product-top-icon"' +
          ' src="' + options.productIcon + '"' +
          ' alt="' + options.productIconTitle + '"' +
          ' title="' + options.productIconTitle + '"' +
          ' data-icon-product/>';
      }

      var priceTemplate = '';
      var overlay = '';
      var overlayOptions = window.shop.productOptions.overlayImages;

      if (product.title.indexOf('RESERVED') !== -1) {
        priceTemplate = 'Reserved';
        overlay = '<img class="prod-img-overlay reserved" src="'+ overlayOptions.reserved +'" alt="" aria-hidden="true" />';
      } else if (product.inventory_quantity < 0 || product.inventory_quantity === 0) {
        priceTemplate = 'Sold';

        overlay = '<img class="prod-img-overlay sold" src="'+ overlayOptions.sold +'" alt="" aria-hidden="true" />';
      } else if (product.price == 9999) {
        priceTemplate = 'Contact / email for Pricing';
      } else {
        var compareAtPrice = (+product.compare_at_price).toFixed(2).replace(/\B(?=(\d\d\d)+\b)/g, ","),
          price = product.price.toFixed(2).replace(/\B(?=(\d\d\d)+\b)/g, ",");
        priceTemplate = compareAtPrice !== '0.00' ? '<span class="reducedfrom">$' + compareAtPrice + '</span> $' + price : '$' + price;
      }

      if(product.price + '00' !== overlayOptions.settings.valueProductCall &&
        (product.title.indexOf('CLEARANCE') !== -1 || (+product.compare_at_price) > product.price * 2) && overlay === '') {
        overlay = '<img class="prod-img-overlay clearance" src="'+ overlayOptions.clearance +'" alt="" aria-hidden="true" />';
      } else if (product.tags.indexOf('New Arrivals') !== -1  && overlay === '') {
        overlay = '<img class="prod-img-overlay newarrival" src="'+ overlayOptions.newArrival +'" alt="" aria-hidden="true" />';
      } else if (product.tags.indexOf('STPIX') !== -1  && overlay === '') {
        overlay = '<img class="prod-img-overlay stpix" src="'+ overlayOptions.staffPicks +'" alt="" aria-hidden="true" />';
      } else if (product.tags.indexOf('COLLECTOR') !== -1  && overlay === '') {
        overlay = '<img class="prod-img-overlay collector" src="'+ overlayOptions.collector +'" alt="" aria-hidden="true" />';
      }

      var wishListDiv = `<div class="vt-wishlist-custom-plp vt-wishlist-container"
        data-product="${product.pid}"
        data-variant="${product.vid}"
        data-product-handle="${product.handle}"
        data-product-image="${product.image_src}"
        data-product-title="${product.title}"
      ></div>`

      return '<div class="imgcont">' +
        '       <a target="_blank" class="imgswitch" title="' + product.title + '" href="/products/' + product.handle + '">' +
        '           <img src="' + getSmallImagePath(product.image_src) + '" alt="' + product.title + '" style="opacity: 1;">' +
        '           <div class="altimgcont">' +
        '               <img class="altimg" src="' + getSmallImagePath(product.image2_src) + '" alt="' + product.title + '" style="opacity: 0;">' +
        '           </div>' +
        '        </a>' + quickViewBtn +
                overlay +
        '   </div>' +
        '   <p class="title">' +
        '       <a target="_blank" href="/products/' + product.handle + '">' + product.title + '</a>' + icon +
        '   </p>' + wishListDiv +
        '   <a class="desc" href="/products/' + product.handle + '" >' + product.body_html + '...</a>' +
        '   <div class="price" price-handle="' + product.handle + '">' +
        '       <div class="price">' +
        '           <span class="actual text_free_price">' +
        '                    ' + priceTemplate +
        '           </span>' +
        '       </div>' +
        '   </div>';
    }
  }

  /**
   *
   * @param $container
   * @param onRemoveFilterTag
   * @param visible
   * @constructor
   */
  function AppliedFilterTags($container, onRemoveFilterTag, visible) {

    var additionalClass = visible ? '' : 'hide';
    $container.html('<div class="applied-filter ' + additionalClass + '" data-tags-container>' + '</div>');

    /**
     *
     * @param tagsData
     */
    this.setTags = function (tagsData) {
      var adminFields = searchableFields.filter(function(field) {
        return field.admin_only === 1;
      });
      var filteredTagsData = tagsData.filter(function(tag) {
        var availableFieldStatus = true;
        adminFields.forEach(function(adminField) {
          if(adminField.title === tag.label && !window.shop.customer.isAdmin) {
            availableFieldStatus = false;
          }
        });

        return availableFieldStatus;
      });

      $container.find('[data-tag-item]').remove();
      $container.find('[data-tags-container]').prepend(_getTemplate(filteredTagsData));
    };

    /**
     *
     * @returns {*}
     */
    this.getCountTag = function () {
      return $container.find('[data-tag-item]').length;
    };

    /**
     *
     */
    this.clearAllTags = function () {
      var tags = $container.find('[data-tag]'),
        removedTags = [];
      tags.each(function (index, tag) {
        removedTags.push({
          name: $(tag).attr('data-name'),
          value: $(tag).attr('data-value')
        });
      });
      onRemoveFilterTag(removedTags);
    };

    /**
     *
     */
    $container.on('click', function (e) {
      var $target = $(e.target);
      if ($target.is('[data-tag]')) {
        onRemoveFilterTag([{
          name: $target.attr('data-name'),
          value: $target.attr('data-value')
        }]);
      }
    });

    /**
     *
     * @param tagsData
     * @returns {string}
     * @private
     */
    var _getTemplate = function (tagsData) {
      var template = '';
      for (var i = 0; i < tagsData.length; i++) {
        template += _getTemplateTag(tagsData[i]);
      }
      return template;
    }

    /**
     *
     * @param tag
     * @returns {string}
     * @private
     */
    var _getTemplateTag = function (tag) {
      var style = typeof tag.color !== 'undefined' ? 'style="background: ' + tag.color + '"' : '';
      var close = tag.name !== 'collectionId' ? '<span class="applied-filter__close" data-value="' + tag.dataValue + '" data-name="' + tag.name + '" data-tag>&#215;</span>' : '';
      if(tag.label === 'Width max' || tag.label === 'Width min' || tag.label === 'Length min' || tag.label === 'Length max') {
      	tag.value = tag.value + ' inch';
      }
      var separator = tag.label === '' ? '' : ': ';
      return '' +
        '<div class="applied-filter__item" data-tag-item ' + style + '>' +
        '   <span class="applied-filter__label">' + tag.label + separator + '</span>' +
        '   <span class="applied-filter__value">' + tag.value + '</span>' +
        close +
        '</div>'
    }
  }

  /**
   *
   */
  function PreLoader(image) {
    var loader = null;
    (function (image) {
      $(document.body).prepend('<div class="pre-loader" data-loader><img src="' + image + '" alt="loader"></div>');
      loader = $(document).find('[data-loader]');
    })(image)

    this.show = function () {
      if (loader) {
        loader.addClass('show');
      }
    }

    this.hide = function () {
      if (loader) {
        loader.removeClass('show');
      }
    }
  }

  /**
   * SEARCH FORM
   * @param $container
   * @param searchableFields
   * @param onChange
   * @param onSubmit
   * @param onCopyData
   * @param options
   * @constructor
   */
  function SearchForm($container, searchableFields, onChange, onSubmit, onCopyData, options) {

    var wasShowed = false,
      sizeFields = ['inch_wid_rgc_dym_min', 'inch_wid_rgc_dym_max', 'inch_len_rgc_dym_min', 'inch_len_rgc_dym_max'],
      rangeFields = ['price_min', 'price_max'].concat(sizeFields);
    var formBuilder = new FormBuilder(),
      formData = _getFormData(searchableFields);
    formBuilder.renderForm($container, formData, options.formId, options.isAdmin);
    var $form = $container.find('form');
    var defaultValues = _getDefaultValues();

    $container.prepend('<div class="searchable-tags"></div>');
    var tags = new AppliedFilterTags($container.find('.searchable-tags'), _onRemoveFilterTag, options.filterTags);

    if (options.showButton) {
      var editButton = _initEditButton($container.find('[data-tags-container]'));
    }

    if (options.copyLink) {
      _initCopyLinkButton($container.find('form [name="submit"]').parent());
    }

    if (options.clearButton) {
      _initClearButton($container.find('[data-tags-container]'));
    }

    if (options.showTotal) {
      _initShowTotal($container.find('form [name="submit"]').parent());
    }

    this.getValues = function () {
      return formBuilder.getFormData($form);
    };

    this.init = function (values) {
      _init(values);
    };

    this.setTotalValue = function (value) {
      if (options.showTotal) {
        var showTotal = $container.find('[data-show-total]');
        showTotal.each(function() {
          $(this).text(value);
        });
      }
    };

    /**
     *
     * @returns {boolean}
     */
    this.isDefault = function (values) {
      var result = true;
      for (var i = 0; i < defaultValues.length; i++) {
        var defaultItem = defaultValues[i];
        var isFind = false;
        for (var j = 0; j < values.length; j++) {
          var value = values[j];
          if (value.name === defaultItem.name && value.value === defaultItem.value) {
            isFind = true;
            break;
          }
        }
        if (!isFind) {
          result = false;
          break;
        }
      }
      return result;
    };

    /**
     * onChangeForm
     */
    $form.on('change', function () {
      var values = formBuilder.getFormData($(this)),
        formId = $(this).attr('data-form-id');
      tags.setTags(_getTagsValuesFromData(values))
      options.customFilterTags.forEach(function (tag) {
        values.push({name: tag.name, value: tag.dataValue});
      });

      onChange(values, formId);
    });

    /**
     * onSubmitForm
     */
    $form.on('submit', function (e) {
      e.preventDefault();
      var values = formBuilder.getFormData($(this)),
        formId = $(this).attr('data-form-id');
      onSubmit(values, formId);
    });

    /**
     *
     * @param values
     * @private
     */
    function _init(values) {
      _updateFieldValuesForm($form, values);
      tags.setTags(_getTagsValuesFromData(values));
      if (options.showButton && !wasShowed) {
        if (tags.getCountTag() && options.filterTags) {
          $form.addClass('hide');
          $form.submit();
        } else {
          editButton.click();
        }
      }
    }

    /**
     *
     * @returns {[]}
     * @private
     */
    function _getFormData(searchableFields) {
      var formData = [];
      for (var key in searchableFields) {
        if (searchableFields.hasOwnProperty(key)) {
          formData.push(searchableFields[key]);
        }
      }
      if (options.submitButton) {
        //console.log('formData');
        //console.log(formData);
        formData.push({
          name: 'submit',
          type: 'submit',
          title: 'View Results',
          class: 'els-form__line_flex'
        });
      }
      return formData;
    }

    /**
     *
     * @param querySelector
     * @param onClick
     * @private
     */
    function _initCustomButton(querySelector, onClick) {
      var $button = $container.find(querySelector);
      $button.on('click', onClick);
      return $button;
    }

    /**
     *
     * @param $container
     * @private
     */
    function _initEditButton($container) {
      $container.append('<a href="#" class="els-form__link els-form__link_tag" data-edit-button>Edit</a>');
      return _initCustomButton('[data-edit-button]', function (e) {
        e.preventDefault();
        $(this).addClass('hide');
        $form.removeClass('hide');
        wasShowed = true;
        _initCollapseButton($container);
      })
    }

    /**
     *
     * @param $container
     * @private
     */
    function _initCollapseButton($container) {
      $container.append('<a href="#" class="els-form__link els-form__link_tag" data-collapse-button>Collapse</a>');
      return _initCustomButton('[data-collapse-button]', function (e) {
        e.preventDefault();
        $(this).addClass('hide');
        $form.addClass('hide');
        wasShowed = true;
        _initEditButton($container);
      })
    }

    /**
     *
     * @param $container
     * @private
     */
    function _initCopyLinkButton($container) {
      $container.append('<a href="#" class="els-form__link with-right-padding" data-link>Share Link</a>');
      _initCustomButton('[data-link]', function (e) {
        e.preventDefault();
        onCopyData(function (data) {
          var linkValueInput = document.createElement('input');
          data = data.replace(/ /g, "%20");
          linkValueInput.value = data;
          document.body.appendChild(linkValueInput);
          linkValueInput.select();
          document.execCommand('copy');
          linkValueInput.remove();
        });

        var target = $(this),
          text = target.text();
        target.text('Copied');
        setTimeout(function () {
          target.text(text);
        }, 500);
      })
    }

    /**
     *
     * @param $container
     * @private
     */
    function _initClearButton($container) {
      $container.prepend('<a href="#" class="els-form__link els-form__link_tag" data-clear>Reset to default</a>');
      return _initCustomButton('[data-clear]', function (e) {
        e.preventDefault();
        _init(defaultValues);
        onChange(defaultValues, options.formId);
      }.bind(this))
    }

    /**
     *
     * @param $container
     * @private
     */
    function _initShowTotal($container) {
      $container.prepend('<span class="els-form__text full">Number Of Search Results: <span data-show-total>0</span></span>');
    }

    /**
     *
     * @param name
     * @returns {null|*}
     * @private
     */
    function _getSearchableFieldByName(name) {
      for (var i = 0; i < searchableFields.length; i++) {
        if (searchableFields[i].name === name) {
          return searchableFields[i];
        }
      }
      return null;
    }

    /**
     *
     * @param $form
     * @param values
     * @private
     */
    function _updateFieldValuesForm($form, values) {
      var checkboxes = $form.find('[type="checkbox"]');
      checkboxes.prop('checked', false);
      for (var i = 0; i < values.length; i++) {
        var value = values[i],
          fields = $form.find('[name="' + value.name + '"]');

        if(sizeFields.indexOf(value.name) !== -1) {
        	var feetsFieldName  = value.name + '_ft';
          	var inchesFieldName = value.name + '_inch';
          _updateFieldValue($('[name="'+ feetsFieldName +'"]'), {name: feetsFieldName, value: Math.floor(value.value / 12)}, value.value);
          _updateFieldValue($('[name="'+ inchesFieldName +'"]'), {name: inchesFieldName, value: value.value % 12}, value.value);
        } else {
          for (var j = 0; j < fields.length; j++) {
            _updateFieldValue($(fields[j]), value)
          }
        }
      }
    }

    /**
     *
     * @returns {[]}
     * @private
     */
    function _getDefaultValues() {
      var defaultValues = [];
      for (var key in searchableFields) {
        if (searchableFields.hasOwnProperty(key)) {
          var searchableField = searchableFields[key];
          switch (searchableField.type) {
            case 'checkbox': {
              if (searchableField.value.length > 0) {
                defaultValues.push({
                  name: searchableField.name + '_checkbox',
                  value: searchableField.value
                });
              }
            }
              break;
            case 'select':
            case 'text': {
              defaultValues.push({
                name: searchableField.name,
                value: searchableField.value
              });
            }
              break;
            case 'range': {
              defaultValues.push({
                name: searchableField.name + '_' + searchableField.min.label,
                value: searchableField.min.value
              });
              defaultValues.push({
                name: searchableField.name + '_' + searchableField.max.label,
                value: searchableField.max.value
              });
            }
          }
        }
      }
      options.customFilterTags.forEach(function (tag) {
        defaultValues.push({
          name: tag.name,
          value: tag.dataValue
        });
      });

      defaultValues = defaultValues.map(function(item) {
        if(rangeFields.indexOf(item.name) !== -1) {
          item.value = parseInt(item.value);
        }
        return item;
      });

      return defaultValues;
    }

    /**
     *
     * @param $field
     * @param value
     * @private
     */
    function _updateFieldValue($field, value, valueInInches = false) {
      var type = $field.prop('type');
      switch (type) {

        case 'text': {
          if ($field.val() !== value.value) {
            $field.val(value.value);
          }
        }
          break;
        case 'checkbox': {
          if ($field.val() === value.value) {
            $field.prop('checked', true);
          }
        }
          break;
        case 'select-one': {
          $field.find('option[value="' + value.value + '"]').prop('selected', true);
          $field.parent().find('.selectpicker').text(value.value);
        }
          break;
        case 'number': {
          if (+$field.val() !== +value.value) {
            	var range = $field.closest('.els-form__range').find('.nstSlider');
            if(valueInInches) {
              	var min = value.name.indexOf('_min') !== -1 ? valueInInches : range.nstSlider('get_current_min_value'),
                	max = value.name.indexOf('_min') !== -1 ? range.nstSlider('get_current_max_value') : valueInInches;
                range.nstSlider('set_position', min, max);
            	$field.val(value.value);
            } else {
                var min = value.name.indexOf('_min') !== -1 ? value.value : range.nstSlider('get_current_min_value'),
                	max = value.name.indexOf('_min') !== -1 ? range.nstSlider('get_current_max_value') : value.value;
                range.nstSlider('set_position', min, max);
                $field.val(value.value);
            }

          }
        }
      }
    }

    /**
     *
     * @param tagValues
     * @private
     */
    function _onRemoveFilterTag(tagValues) {
      var values = formBuilder.getFormData($form);
      options.customFilterTags.forEach(function (tag) {
        values.push({
          name: tag.name,
          value: tag.dataValue
        });
      });
      tagValues.forEach(function (tag) {
        var name = tag.name,
          value = tag.value;
        var searchableField = _getSearchableFieldByName(name.replace(/(_min$)|(_max$)|(_checkbox$)/gi, ''));
        if (searchableField) {
          switch (searchableField.type) {
            case 'text' :
            case 'select' : {
              for (var i = 0; i < values.length; i++) {
                if (values[i].name === searchableField.name) {
                  if(values[i].name === 'sku' || values[i].name === 'wash_output_rgc_zvc_dym') {
                    var separator = ' ';
                    if(values[i].value.indexOf(',') !== -1) {
                    	separator = ', ';
                    }
                    values[i].value = values[i].value.replace(/\s+/g, ' ');
                    var parts = values[i].value.split(separator);
                    var savedParts = [];
                    for(var k = 0; k < parts.length; k++) {
                      if(parts[k] !== value) {
                        savedParts.push(parts[k]);
                      }
                    }
                    values[i].value = savedParts.join(separator);
                  } else {
                    values[i].value = searchableField.value;
                  }
                  break;
                }
              }
            }
              break;
            case 'checkbox' : {
              for (var i = 0; i < values.length; i++) {
                if ((value === values[i].value && values[i].name === searchableField.name + '_checkbox') || values[i].name === searchableField.name) {
                  values.splice(i, 1);
                  break;
                }
              }
            }
              break;
            case 'range' : {
              for (var i = 0; i < values.length; i++) {
                if (name === values[i].name && name === searchableField.name + '_min') {
                  values[i].value = parseInt(searchableField.min.value);
                  break;
                } else if (name === values[i].name && name === searchableField.name + '_max') {
                  values[i].value = parseInt(searchableField.max.value);
                  break;
                }
              }
            }
          }
        }
      });

      _updateFieldValuesForm($form, values);
      tags.setTags(_getTagsValuesFromData(values));
      onChange(values, $form.attr('data-form-id'));
    }

    /**
     *
     * @param data
     * @returns {[]}
     * @private
     */
    function _getTagsValuesFromData(data) {
      var tags = [];

      for (var i = 0; i < data.length; i++) {
        var searchableField = _getSearchableFieldByName(data[i].name.replace(/(_min$)|(_max$)|(_checkbox$)/gi, ''))
        if (searchableField) {
          var value = null;
          if (searchableField.type === 'text' && searchableField.value !== data[i].value) {
            if((data[i].name === 'sku' || data[i].name === 'wash_output_rgc_zvc_dym') && data[i].value !== '') {
              var separator = ' ';
              if(data[i].value.indexOf(',') !== -1) {
                separator = ', ';
              }
              data[i].value = data[i].value.replace(/\s+/g, ' ');
              var parts = data[i].value.split(separator);

              for(var c = 0; c < parts.length; c++) {
                if(c === 0) {
                  tags.push({name: data[i].name, value: parts[c], dataValue: parts[c], label: searchableField.title});
                } else {
                  tags.push({name: data[i].name, value: parts[c], dataValue: parts[c], label: ''});
                }
              }
              continue;
            }
            value = {
              'label': searchableField.title,
              'value': data[i].value,
              'name': data[i].name,
              'dataValue': data[i].value
            };
          } else if (searchableField.type === 'select') {
            value = _getTagValueForSelect(data[i], searchableField)
          } else if (searchableField.type === 'range') {
            value = _getTagValueForRange(data[i], searchableField);
          } else if (searchableField.type === 'checkbox') {
            value = _getTagValueForCheckBox(data[i], searchableField);
          }
          if (value) {
            tags.push(value);
          }
        }
      }
      options.customFilterTags.forEach(function (tag) {
        tags.push(tag);
      });

      return tags;
    }

    /**
     *
     * @param data
     * @param searchableField
     * @returns {*}
     * @private
     */
    function _getTagValueForRange(data, searchableField) {
      var key = data.name.indexOf('_min') !== -1 ? 'min' : data.name.indexOf('_max') !== -1 ? 'max' : null;
      return key && +data.value !== +searchableField[key].value ? {
        'label': searchableField.title + ' ' + key,
        'value': data.value,
        'name': data.name,
        'dataValue': data.value
      } : null;
    }

    /**
     *
     * @param data
     * @param searchableField
     * @returns {*}
     * @private
     */
    function _getTagValueForSelect(data, searchableField) {
      return _getTagValueForCheckBox(data, searchableField)
    }

    /**
     *
     * @param data
     * @param searchableField
     * @returns {*}
     * @private
     */
    function _getTagValueForCheckBox(data, searchableField) {
      var labelValue = '',
        value = '',
        options = searchableField.options;
      for (var i = 0; i < options.length; i++) {
        if (options[i].value + '' === data.value + '') {
          labelValue = options[i].label + '';
          value = options[i].value + '';
          break;
        }
      }
      return labelValue.length > 0 ? {
        'label': searchableField.title,
        'value': labelValue,
        'name': data.name,
        'dataValue': value
      } : null;
    }
  }

if (
    window.shop.page !== 'page/advanced-search' &&
    window.matchMedia("(min-width: 768px)").matches) {
    var sideBar = new SideBar({
        position: 'left',
        label: window.shop.customSettings.label.text.reset,
        size: 50,
        customClass: 'fixed-result-button',
        imageLabel: window.shop.customSettings.label.image,
        body: '' +
            '<div>' +
            '    <div class="searchable-tags"></div>' +
            '<div class="searchable-form-container" data-with-submit-button data-form-id="side-bar-form"></div>' +
            '</div>'
    });
}

  var
    limit = 45,
    wasSubmitted = false,
    searchableFields = window.shop.searchableFields,
    shopDomain = window.shop.domain,
    collection = window.shop.collection,
    customer = window.shop.customer,
    customTagColor = window.shop.customTagColor,

    apiUrl = 'https://staging-app.oldnewhouse.com/api/advanced-search/get-products',
    searchDataFromUrl = getSearchDataFromUrl(),
    searchValuesFromUrl = getPrepareSearchData(searchDataFromUrl, collection),
    collectionDataFormUrl = getCollectionDataFormSearchData(searchDataFromUrl),
    formContainers = $('.searchable-form-container'),
    productsContainer = $('.container .productlist, .productlist'),
    paginatorContainer = $('.paging'),
    loader = new PreLoader(window.shop.loaderIcon),
    storage = (function (window) {
      var storageKeyValue = 'searchForm';
      var callbacks = [];

      function getValues() {
        return window.localStorage.hasOwnProperty(storageKeyValue) ? JSON.parse(window.localStorage.getItem(storageKeyValue)) : [];
      }

      function setValues(values, clientId) {
        window.localStorage.setItem(storageKeyValue, JSON.stringify(values));
        if (typeof clientId !== "undefined") {
          callbacks.filter(function (item) {
            return item.id !== clientId
          }).forEach(function (item) {
            item.callback(values, item.id);
          })
        }
      }

      function onChange(clientId, callback) {
        callbacks.push({
          id: clientId,
          callback: callback
        });
      }

      return {getValues, setValues, onChange, callbacks};
    })(window),

    api = (function (options) {
      function getProducts(values, page, callback) {
        $.ajax({
          method: 'GET',
          data: {
            domain: options.shop,
            options: values,
            limit: limit,
            page: page
          },
          url: options.apiUrl,
          success: function (data) {
            callback(data)
          }
        });
      }

      return {getProducts}
    })({'shop': shopDomain, 'apiUrl': apiUrl}),
    searchableForms = {};

  if (searchValuesFromUrl.length > 0) {
    storage.setValues(searchValuesFromUrl);
  }

  var values = storage.getValues();

  values = storage.getValues().filter(function (value) {
    if (value.name !== 'collectionId') return value;
  });

  if (collection) {
    values.push({
      name: 'collectionId',
      value: collection.id
    });
    storage.setValues(values);
  }

  var customFilterTags = [];

  if (collection) {
    customFilterTags = [{
      'label': 'Collection',
      'value': collection.title,
      'name': 'collectionId',
      'dataValue': collection.id,
      'color': customTagColor,
    }];
  } else if (collectionDataFormUrl) {
    customFilterTags = [{
      'label': 'Collection',
      'value': collectionDataFormUrl.name,
      'name': 'collectionId',
      'dataValue': collectionDataFormUrl.value,
      'color': customTagColor,
    }];
  }

  $.each(formContainers, function (index, container) {
    var $container = $(container),
      formId = $container.attr('data-form-id');

    searchableForms[formId] = new SearchForm($container, searchableFields, onChange, onSubmit, onCopyData, {
      formId: formId,
      isAdmin: customer.isAdmin,
      showTotal: window.shop.page === 'page/advanced-search',
      submitButton: $container.is('[data-with-submit-button]'),
      showButton: $container.is('[data-with-show-button]'),
      filterTags: true,
      copyLink: true,
      clearButton: true,
      customFilterTags: customFilterTags
    });

    storage.onChange(formId, onStorageChange);

    if (values.length === 0) {
      values = searchableForms[formId].getValues();
      storage.setValues(values);
    }
    searchableForms[formId].init(values);
    toggleSidBarLabel(searchableForms[formId].isDefault(values));
  });


  list = new ProductsList(productsContainer, paginatorContainer, onPageChange, window.shop.productOptions);

  storage.onChange('fetch', function () {
    if (wasSubmitted) {
      fetchProducts(1);
    }
  });

  /**
   *
   * @param values
   * @param formId
   */
  function onStorageChange(values, formId) {
    if (searchableForms.hasOwnProperty(formId)) {
      searchableForms[formId].init(values);
    }
  }

  /**
   *
   * @param values
   * @param formId
   */
  function onChange(values, formId) {
    storage.setValues(values, formId);
    toggleSidBarLabel(searchableForms[formId].isDefault(values));
  }

  /**
   *
   */
  function onSubmit() {
    if (collection || window.shop.page === 'page/advanced-search') {
      if (collection) {
        paginatorContainer.addClass('onh-f-paginator');
        document.querySelector('.collection-tools-box').style.display = 'none';
        sideBar.hide();
      }
      fetchProducts(1);
      wasSubmitted = true;
    } else {
      window.location.href = getUrlFormStorage();
    }
  }

  /**
   *
   * @param page
   */
  function onPageChange(page) {
    fetchProducts(page);
    $('html, body').animate({scrollTop: $('.container .productlist').offset().top - 10}, 500);
  }

  /**
   *
   * @param callBack
   */
  function onCopyData(callBack) {
    callBack(getUrlFormStorage());
  }

  /**
   *
   * @param isDefault
   */
  function toggleSidBarLabel(isDefault) {
    if (typeof sideBar !== 'undefined') {
      sideBar.setLabelText(isDefault ? window.shop.customSettings.label.text.reset : window.shop.customSettings.label.text.modify);
    }
  }

  function renderNotFoundProducts() {
    var notFoundProductsHtml = window.shop.notFoundHtml;
    if(notFoundProductsHtml.indexOf('href=') !== -1) {
    	var htmlParts = notFoundProductsHtml.split('href='),
      	    quote = htmlParts[1][0],
      	    linkParts = htmlParts[1].split(quote),
            lastLinkString = '',
      	    wholeLink = getUrlFormStorage(),
      	    wholeLinkParts = wholeLink.split('?');
        for(var i = 2; i < linkParts.length; i++) {
			lastLinkString = lastLinkString + linkParts[i];
        }

        if(wholeLinkParts.length === 2) {
        	var linkAttributes = wholeLinkParts[1].split('&');
          	var preparedAttributesString = '';
            for(var i = 0; i < linkAttributes.length; i++) {
                if(linkAttributes[i].substring(0,11) !== 'collection=') {
                    if(preparedAttributesString !== '') {
						preparedAttributesString += '&' + linkAttributes[i];
                    } else {
                    	preparedAttributesString = linkAttributes[i];
                    }
                }
            }
          	wholeLink = wholeLinkParts[0] + '?' + preparedAttributesString;
          	notFoundProductsHtml = htmlParts[0] + 'href='+ quote + wholeLink + quote + lastLinkString;
        }
    }
    productsContainer.html(notFoundProductsHtml);
    list = new ProductsList(productsContainer, paginatorContainer, onPageChange, window.shop.productOptions);
  }

  /**
   *
   * @param page
   */
  function fetchProducts(page) {
    var values = storage.getValues();
    values = getPrepareValues(values);
    loader.show();

    if(window.shop.customer.isAdmin){
    	values.push({name: 'inspect', value: true, type: "text"})
    }

    api.getProducts(values, page, function (data) {
      for (var formId in searchableForms) {
        if (searchableForms.hasOwnProperty(formId)) {
          searchableForms[formId].setTotalValue(data.total);
        }
      }
      if(data.items.length === 0 && window.location.pathname.indexOf('/collections/') !== -1) {
      	renderNotFoundProducts();
      } else {
      	list.setProducts(data.items);
      }
        list.setPaginator({
          'total': data.total,
          'page': data.page,
          'limit': limit
        });

      loader.hide();
    })
  }

  /**
   *
   * @param name
   * @returns {null|*}
   * @private
   */
  function getSearchableFieldByName(name) {
    name = name.replace('_checkbox', '').replace('_min', '').replace('_max', '');
    for (var i = 0; i < searchableFields.length; i++) {
      if (searchableFields[i].name === name) {
        return searchableFields[i];
      }
    }
    return null;
  }

  /**
   *
   * @param values
   * @returns {any[] | string}
   */
  function getPrepareValues(values) {
    var data = [];
    values.forEach(function (value) {
      var searchableField = getSearchableFieldByName(value.name);
      if (searchableField && (searchableField.type === 'select' || searchableField.type === 'checkbox') && ~value.value.indexOf(",")) {
        var splitValues = value.value.split(',');
        splitValues.forEach(function (splitValue) {
          data.push({
            name: value.name,
            value: splitValue.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''),
            type: searchableField.type
          })
        })
      } else {
        data.push({
          name: value.name,
          value: value.value,
          type: searchableField !== null ? searchableField.type : null
        })
      }
    });
    return data;
  }

  /**
   *
   * @returns {string}
   */
  function getUrlFormStorage() {
    var values = storage.getValues(),
      search = [],
      collectionId = null;
    values.filter(function (value) {
      collectionId = value.value;
      return value.name !== 'collectionId'
    }).forEach(function (value) {
      search.push(value.name + '=' + value.value);
    });
    if (collection) {
      search.push(encodeURI('collection=' + collection.id + '||' + collection.title));
    } else if (collectionDataFormUrl) {
      search.push(encodeURI('collection=' + collectionDataFormUrl.value + '||' + collectionDataFormUrl.name));
    }
    search = search.join('&');
    return window.location.origin + '/pages/advanced-search?' + search;
  }

  /**
   *
   * @returns {array}
   */
  function getSearchDataFromUrl() {
    var data = [];
    if (window.location.search.length > 0) {
      var searchData = window.location.search.substr(1);
      searchData = searchData.split('&');
      searchData.forEach(function (item) {
        item = item.split('=');
        if (typeof item[0] !== 'undefined' && typeof item[1] !== 'undefined' && (item[0] === 'collection' || getSearchableFieldByName(item[0]) != null)) {
          data.push({
            name: item[0],
            value: decodeURI(item[1])
          });
        }
      });
    }
    return data;
  }

  /**
   *
   * @param searchData
   * @param collection
   * @returns {[]}
   */
  function getPrepareSearchData(searchData, collection) {
    var prepareSearchData = [],
      collectionExist = false;
    searchData.forEach(function (item) {
      if (!collectionExist && item.name === 'collection') {
        var value = item.value.split('||');
        if (value.length === 2) {
          value = collection ? collection.id : value[0];
          prepareSearchData.push({
            name: 'collectionId',
            value: value
          });
          collectionExist = true
        }
      } else {
        prepareSearchData.push(item);
      }
    });

    if (!collectionExist && collection && searchData.length > 0) {
      prepareSearchData.push({
        name: 'collectionId',
        value: collection.id
      });
    }
    return prepareSearchData;
  }

  /**
   *
   * @param {array} searchData
   * @returns {string}
   */
  function getCollectionDataFormSearchData(searchData) {
    var collectionData = null;
    searchData.forEach(function (item) {
      if (item.name === 'collection') {
        var value = item.value.split('||');
        if (value.length === 2) {
          collectionData = {
            name: decodeURI(value[1]),
            value: decodeURI(value[0])
          };
          return collectionData;
        }
      }
    });

    return collectionData;
  }
})();